import { useCallback, useContext, useMemo, useState } from "react";
import ImpactList from "../ImpactList";
import { useConfirmModal } from "./useConfirmModal";
import { ProfileContext } from "../../context";
import { useAccess } from "../../../../utils/hooks/access";
import { getDefaultShiftActions, toShiftActionItems } from "../helpers";

export const useImpactConfirmModal = ({ message, onConfirm }) => {
    const { isSelf } = useContext(ProfileContext);
    const { hasAccess: canEdit } = useAccess("schedule.canEdit");
    const canMove = isSelf || canEdit;
    const { hasAccess: canDelete } = useAccess(isSelf ? "schedule.canDeleteMySchedule" : "schedule.canDelete");
    const permissions = useMemo(() => ({ canMove, canDelete }), [canMove, canDelete]);

    const [impact, setImpact] = useState();
    const [shiftActions, setShiftActions] = useState({});

    const hasShifts = !!impact?.shifts?.items?.length;
    const blocked = hasShifts && !canMove && !canDelete;
    const missingAction = !!impact?.shifts?.items?.some((shift) => !shiftActions[shift.shiftId]);

    const renderMessage = useCallback(() => (
        <ImpactList
            message={message}
            impact={impact}
            shiftActions={shiftActions}
            onShiftActionsChange={setShiftActions}
            permissions={permissions}
        />
    ), [message, impact, shiftActions, permissions]);

    const { open: openModal, modal } = useConfirmModal({
        message: renderMessage,
        onConfirm: blocked || missingAction
            ? undefined
            : (item) => onConfirm(item, toShiftActionItems(item?.impact?.shifts?.items, shiftActions)),
    });

    const open = useCallback((item) => {
        setImpact(item.impact);
        setShiftActions(getDefaultShiftActions(item.impact?.shifts?.items, permissions));
        openModal(item);
    }, [openModal, permissions]);

    return { open, modal };
};
